<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <div class="form-group form-actions float-right pb-2">
          <b-button class="mr-2" type="submit" size="md" variant="primary" @click="newUser">
            <i class="fa fa-user-plus"></i>
            New User
          </b-button>
        </div>
        <div>
          <StyledDialog :CurrentObject="mySelected" EntityType="N_User">
            <div slot="header">
              <h2>{{mySelected.FirstName}} {{mySelected.LastName}}</h2>
            </div>
            <div slot="details">
              <div>{{mySelected.Title}}</div>
              <div>{{mySelected.Email1}}</div>
            </div>
            <span slot="entityType">User</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="n_user.n_users"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "MyUserList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "UserName",
          label: "UserName",
          sortable: true
        },
        {
          key: "FirstName",
          label: "First",
          sortable: true
        },
        { key: "LastName", label: "Last", sortable: true },
        { key: "Title", label: "Title", sortable: true },
        { key: "Email1", label: "Email", sortable: true }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  created() {
    this.$store.dispatch("n_user/fetchUsers");
  },
  computed: {
    totalRows: function() {
      return this.$store.state.n_user.n_users.length;
      //return 4;
    },
    isNavVisible: function() {
      return this.totalRows > this.perPage;
    },
    ...mapState(["n_user", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    //incrementCount() {
    //  this.$store.commit("INCREMENT_COUNT");
    //}
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      //this.mySelected = record;
      this.$store
        .dispatch("n_user/loadUserEdit", record.UserProfileID)
        .then(() => {
          this.$router.push({ name: "User" });
        });
    },
    newUser() {
      //this.$store.dispatch("n_user/createUser", this.createFreshUserObject());
      this.$store
        .dispatch("n_user/New")
        .then(() => {
          this.$router.push({
            name: "User"
            //,
            //params: { id: this.event.id }
          });
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshUserObject() {
      return {
        id: -1,
        UserName: "New User",
        FirstName: "Test"
      };
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>